module.exports = __webpack_public_path__ + "img/page2-bg.86a3de50.png";